import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredRole?: 'admin' | 'client';
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  requiredRole,
}) => {
  const { user, loading } = useAuth();

  console.log('ProtectedRoute - User:', user?.id, 'Loading:', loading, 'Required role:', requiredRole, 'User role:', user?.role, 'User email:', user?.email);

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Loading application...</p>
          <p className="text-sm text-gray-500 mt-2">Checking authentication status</p>
        </div>
      </div>
    );
  }

  if (!user) {
    console.log('ProtectedRoute - No user, redirecting to login');
    return <Navigate to="/login" replace />;
  }

  // Special case for admin@aicrm.com
  if (user.email === 'admin@aicrm.com') {
    if (requiredRole && requiredRole !== 'admin') {
      console.log('ProtectedRoute - Admin user trying to access client route, redirecting to admin dashboard');
      return <Navigate to="/dashboard" replace />;
    }
  } else if (requiredRole && user.role !== requiredRole) {
    console.log(`ProtectedRoute - Role mismatch: User has ${user.role} role, but ${requiredRole} is required`);
    console.log('ProtectedRoute - Redirecting to appropriate dashboard');
    return <Navigate to={user.role === 'admin' ? '/dashboard' : '/client-portal'} replace />;
  }

  console.log('ProtectedRoute - Access granted');
  return <>{children}</>;
};